import React from "react";
import { Segment, Icon } from "semantic-ui-react";

export const ConfirmationHeader = ({ message }: { message: string }) => {
  return (
    <>
      <div>
        <Segment
          style={{
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 0,
          }}
          inverted
          color='green'
        >
          <Icon size='large' name='check circle' />
          <h1 className='tw-mt-0 tw-text-xl tw-text-white'>{message}</h1>
        </Segment>
      </div>
    </>
  );
};
